import { render, staticRenderFns } from "./btnCancelarGuardar.vue?vue&type=template&id=5fed83cc&scoped=true"
import script from "./btnCancelarGuardar.vue?vue&type=script&lang=js"
export * from "./btnCancelarGuardar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fed83cc",
  null
  
)

export default component.exports